module.exports = __webpack_public_path__ + "img/cc.0a4fef4.svg";